import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { objectEach } from 'highcharts';
import { environment } from 'src/environments/environment';
import { EncrdecrService } from '../Auth/encrdecr.service';
import { ConvertToJSONService } from './convert-to-json.service';
import { firstValueFrom } from 'rxjs';

const headers = { headers: new HttpHeaders({ 'content-type': 'application/json' }) }

@Injectable({
  providedIn: 'root'
})
export class ClientsFilterService {

  private DropDownData: any;
  private ClientData : any;
  ServerUrl = environment.ServerUrl;
  constructor( 
    private http:HttpClient,
    private Encrdecr:EncrdecrService,
    private ConvertToJSON:ConvertToJSONService,
    private EncrdecrService: EncrdecrService
    ) { }

   WrapperApiCall1(data:any,apiSubUrl:string){
    const header = this.GetToken();  
    let url = environment.ServerUrl+apiSubUrl;
    return this.http.post(url,data,header).pipe();
  }

  async WrapperApiCall(data:any,apiSubUrl:string){
    const header = this.GetToken();  
    // let url = environment.ServerUrl+apiSubUrl;
    // return this.http.post(url,data,header).pipe();
    const result = await this.postAPICall(data, apiSubUrl,header);
    return result;
  }

  //dropdownvalues
  setSelectedDropdownData(data : any){
    this.DropDownData = data;
  }
 
  getSelectedDropdownData(){
    return this.DropDownData;
  }
   setClientDropdownData(data:any){
    this.ClientData = data;
  }
  getClientDropdownData(){
    return this.ClientData;
  }
  GetToken(){
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.Encrdecr.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let UserType = this.Encrdecr.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    console.log('token value is '+ token +"@"+UserId+"|"+UserType+"|"+IpAddress);
    const TOKEN = btoa(token +"@"+UserId+"|"+UserType+"|"+IpAddress);
     const tokenOption = { headers:
      new HttpHeaders(
        {'Content-Type': 'application/json',
        'Authorization': `Basic ${TOKEN}`,
      })
    }
    return tokenOption;
  }

  
  //Added by Dalsukh for UnMappedClients
  SearchCustomerRM(Request:any){
    const header = this.GetToken(); 
    let URL = "/api/SearchCustomerRM/GetClientDetails";
    let url = environment.ServerUrl+URL;
    return this.http.post(url,Request,header).pipe();
  }
  async postAPICall(Request: any, URL: any,headersdy = {}): Promise<any> {
    let Url = `${this.ServerUrl}${URL}`;
    // let Url = `http://localhost:2010/${URL}`;

    let KeyPair = await this.EncrdecrService.getKeyPair();
    Request.publicKey = KeyPair.publicKeySpkiBase64;

    let EncryptedData = await this.EncrdecrService.encryptJson(Request, environment.RSA_PUBLIC_KEY_BASE64);

    let body = {
      "EncryptedData": EncryptedData.encryptedData,
      "dvfv": EncryptedData.encryptedKey,
      "sdcsd": EncryptedData.iv
    };
    if(!headersdy){
      headersdy = headers
    }
    const response = await firstValueFrom(this.http.post<any>(Url, body, headersdy));

    const DecryptedResponse = this.EncrdecrService.decryptResponse(
      response.EncryptedDataBase64,
      response.EncryptedAesKeyBase64,
      response.IvBase64,
      KeyPair.privateKeyPem
    );

    return DecryptedResponse;
  }

}
